import { Injectable } from '@angular/core';
import { ServiceProvider } from './service.provider';
import { DMSBaseService } from './dms.base.service';
import { ItemPagination } from 'app/modules/admin/apps/file-manager/file-manager.types';

@Injectable({ providedIn: 'root' })
export class NoteService extends DMSBaseService {
  constructor(public provider: ServiceProvider) {
    super("/notes", provider);
  }

  public addNote(data, docId) {
    if(data.id) return this.edit(data)
    return this.save(data, `/${docId}`);
  }

  public edit(data) {
    return this.update(data, '');
  }

  getNotes(docId){
    return this.getList(`/get-by-asset-id/${docId}`)

  }
}